export const SET_CURRENT_PAGE = "storeCurrentPageData";
export const CURRENT_PAGE_ERROR = "currenPageError";
export const SET_PRELOADER_LOADED = "setPreloaderLoaded";
//campaign
export const SET_CAMPAIGN_DATA = "setCampaignData";
export const SET_CAMPAIGN_DATA_ERROR = "SetCampaignDataError";
export const SET_CAMPAIGN_CURRENT_PAGE = "setCampaignCurrentPage";
export const SET_CAMPAIGN_PARENT_PAGE = "setCampaignParentPage";
// job mutation
export const SET_JOB_DATA = "setJobData";
export const SET_JOB_DATA_ERROR = "SetJobDataError";
export const SET_JOB_CURRENT_PAGE = "setJobCurrentPage";
export const SET_JOB_PARENT_PAGE = "setJobParentPage";


// joblist mutation
export const SET_JOBLIST_DATA = "setJoblistData";
export const SET_JOBLIST_DATA_ERROR = "SetJoblistDataError";
export const SET_JOBLIST_CURRENT_PAGE = "setJoblistCurrentPage";
export const SET_JOBLIST_PARENT_PAGE = "setJoblistParentPage";

// job mutation
export const SET_BRAND_DATA = "setBrandData";
export const SET_BRAND_DATA_ERROR = "SetBrandDataError";
export const SET_BRAND_CURRENT_PAGE = "setBrandCurrentPage";
export const SET_BRAND_PARENT_PAGE = "setBrandParentPage";

export const ADD_ANIMATION = "addMainTimeLineAnimation";



// contact mutation
export const SET_SETTING_DATA = "setSettingData";
export const SET_SETTING_DATA_ERROR = "SetSettingDataError";
export const SET_SETTING_CURRENT_PAGE = "setSettingCurrentPage";
export const SET_SETTING_PARENT_PAGE = "setSettingParentPage";



// contact mutation
export const SET_CONTACT_DATA = "setContactData";
export const SET_CONTACT_DATA_ERROR = "SetContactDataError";
export const SET_CONTACT_CURRENT_PAGE = "setContactCurrentPage";
export const SET_CONTACT_PARENT_PAGE = "setContactParentPage";

// investor mutation
export const SET_INVEST_DATA = "setInvestData";
export const SET_INVEST_DATA_ERROR = "SetInvestDataError";
export const SET_INVEST_CURRENT_PAGE = "setInvestCurrentPage";
export const SET_INVEST_PARENT_PAGE = "setInvestParentPage";

// investor mutation
export const SET_WORK_DATA = "setWorkData";
export const SET_WORK_DATA_ERROR = "SetWorkDataError";
export const SET_WORK_CURRENT_PAGE = "setWorkCurrentPage";
export const SET_WORK_PARENT_PAGE = "setWorkParentPage";

// news mutation
export const SET_NEWS_DATA = "setNewsData";
export const SET_NEWS_DATA_ERROR = "SetNewsDataError";
export const SET_NEWS_CURRENT_PAGE = "setNewsCurrentPage";
export const SET_NEWS_PARENT_PAGE = "setNewsParentPage";

// product mutation
export const SET_PRODUCT_DATA = "setProductData";
export const SET_PRODUCT_DATA_ERROR = "SetProductDataError";
export const SET_PRODUCT_CURRENT_PAGE = "setProductCurrentPage";
export const SET_PRODUCT_PARENT_PAGE = "setProductParentPage";

// MENU mutation

export const SET_MAIN_MENU = "setMainMenu";
export const SET_MAIN_MENU_ERROR = "setMainMenuError";
export const SET_MENU_LOADED = "setMenuLoaded";
// rtMENU mutation

export const SET_RMAIN_MENU = "setRmainMenu";
export const SET_RMAIN_MENU_ERROR = "setRmainMenuError";
export const SET_RMENU_LOADED = "setRmenuLoaded";

// social icon mutation

export const SET_SOCIAL = "setSocial";
export const SET_SOCIAL_ERROR = "setSocialError";
export const SET_SOCIAL_LOADED = "setSocialLoaded";

// global icon mutation

export const SET_GLOBAL = "setGlobal";
export const SET_GLOBAL_ERROR = "setGlobalError";
export const SET_GLOBAL_LOADED = "setGlobalLoaded";